// @flow

import { useState } from 'react';

import { useDispatch } from 'react-redux';

import type { Dispatch, GetState } from 'src/types';

export const MIN_ELEMENTS_TO_BULK = 3;

export const useAddAllProvider = ({
  addAllAction,
}: {
  addAllAction: (Dispatch, GetState) => Promise<any>,
}): ({
  loading: boolean,
  setLoading: boolean => void,
  handleClick: () => Promise<any>,
}) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      await dispatch(addAllAction);
    } finally {
      setLoading(false);
    }
  };

  return { loading, setLoading, handleClick };
};
